export default __webpack_public_path__ + "e679a595a95dc73d703229045cbb8861.png";